import { TituloContainer } from "./styles"

export const Titulo = ({titulo}) => {
    return (
        <TituloContainer>
            <h1>{titulo}</h1>
        </TituloContainer>
    )
}